import * as THREE from "three";

/** Aim any vehicle/ship muzzle at the point represented by its camera reticle
 * ray. The ray origin matters: reusing only its direction from a lower hull
 * creates a parallel ray that can hit nearby terrain below the reticle. */
export function convergeVehicleWeapon(
  muzzle: THREE.Vector3,
  aimRayOrigin: THREE.Vector3,
  aimRayDirection: THREE.Vector3,
  distance: number,
  outTarget: THREE.Vector3,
  outDirection: THREE.Vector3,
): THREE.Vector3 {
  outTarget.copy(aimRayOrigin).addScaledVector(aimRayDirection, Math.max(0, distance));
  return outDirection.copy(outTarget).sub(muzzle).normalize();
}
